// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { Document } from '@shared/data-access/types/engine-types';

export const getDocumentRelationCount = (document: Document): number => {
  const { relations } = document;

  if (!Array.isArray(relations)) {
    return 0;
  }

  return relations.length;
};

export const documentHasRelations = (document: Document): boolean =>
  getDocumentRelationCount(document) > 0;

type EngineErrorPayload = {
  error_code?: string;
  details?: {
    usage_count?: number;
  };
};

const getEngineErrorPayload = (error: unknown): EngineErrorPayload | undefined => {
  const payload = (error as { data?: EngineErrorPayload })?.data;

  return payload && typeof payload === 'object' ? payload : undefined;
};

export const isDocumentResourceInUseError = (error: unknown): boolean =>
  getEngineErrorPayload(error)?.error_code === 'RESOURCE_IN_USE';

export const getDocumentResourceInUseCount = (error: unknown): number | null => {
  const usageCount = getEngineErrorPayload(error)?.details?.usage_count;

  return typeof usageCount === 'number' && usageCount > 0 ? usageCount : null;
};
